// extracted by mini-css-extract-plugin
export default {"emptyLabel":"MedicalReactionContainer_emptyLabel__nioBn"};